import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

function Table({ className, ...props }: ComponentProps<'table'>) {
  return (
    // Gorizontal aylanish jadvalning O'ZIDA qoladi: admin ekranlarida ustun ko'p, va sahifa
    // butunicha yon tomonga siljisa yon panel ham ekrandan chiqib ketardi. `table-scroll`
    // esa o'sha aylanish BORLIGINI ko'rsatadi — chetdagi soya bilan.
    <div data-slot="table-container" className="table-scroll relative w-full overflow-x-auto">
      <table
        data-slot="table"
        className={cn('w-full caption-bottom text-sm', className)}
        {...props}
      />
    </div>
  );
}

function TableHeader({ className, ...props }: ComponentProps<'thead'>) {
  return (
    <thead
      data-slot="table-header"
      className={cn('[&_tr]:border-b [&_tr]:hover:bg-transparent', className)}
      {...props}
    />
  );
}

function TableBody({ className, ...props }: ComponentProps<'tbody'>) {
  return (
    <tbody
      data-slot="table-body"
      className={cn('[&_tr:last-child]:border-0', className)}
      {...props}
    />
  );
}

function TableFooter({ className, ...props }: ComponentProps<'tfoot'>) {
  return (
    <tfoot
      data-slot="table-footer"
      className={cn('bg-muted/50 border-t font-medium [&>tr]:last:border-b-0', className)}
      {...props}
    />
  );
}

function TableRow({ className, ...props }: ComponentProps<'tr'>) {
  return (
    <tr
      data-slot="table-row"
      className={cn(
        // Qator ostidagi rang O'TISH bilan keladi: kursor uzun jadval bo'ylab yurganda
        // bir zumda yonib-o'chadigan fon miltillashday ko'rinadi, 150ms li o'tish esa
        // kursor harakatining o'zi bilan qo'shilib ketadi.
        'hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors duration-(--dur-tap)',
        className,
      )}
      {...props}
    />
  );
}

function TableHead({ className, ...props }: ComponentProps<'th'>) {
  return (
    <th
      data-slot="table-head"
      className={cn(
        'text-muted-foreground bg-muted/25 h-10 px-3 text-left align-middle text-xs font-medium tracking-wide whitespace-nowrap uppercase first:rounded-tl-md last:rounded-tr-md [&:has([role=checkbox])]:pr-0',
        className,
      )}
      {...props}
    />
  );
}

function TableCell({ className, ...props }: ComponentProps<'td'>) {
  return (
    <td
      data-slot="table-cell"
      className={cn('p-3 align-middle [&:has([role=checkbox])]:pr-0', className)}
      {...props}
    />
  );
}

function TableCaption({ className, ...props }: ComponentProps<'caption'>) {
  return (
    <caption
      data-slot="table-caption"
      className={cn('text-muted-foreground mt-4 text-sm', className)}
      {...props}
    />
  );
}

export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };
